import React, { useState } from 'react';
import { 
  ChevronLeft, 
  LogOut, 
  Lock,
  Eye,
  EyeOff,
  Check,
  AlertCircle,
  User
} from 'lucide-react';
import { authService } from '../services/apiService';

const SettingsScreen = ({ userData, onBack, onLogout }) => {
  const [showPasswordForm, setShowPasswordForm] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [passwordSuccess, setPasswordSuccess] = useState('');
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  
  const handlePasswordChange = async () => {
    // Reset messages
    setPasswordError('');
    setPasswordSuccess('');
    
    // Validate passwords
    // if (!password) {
    //   setPasswordError('Vui lòng nhập mật khẩu mới');
    //   return;
    // }
    
    // if (password.length < 6) {
    //   setPasswordError('Mật khẩu phải có ít nhất 6 ký tự');
    //   return;
    // }
    
    // if (password !== confirmPassword) {
    //   setPasswordError('Mật khẩu xác nhận không khớp');
    //   return;
    // }
    
    // Change password
    setIsChangingPassword(true);
    try {
      const response = await authService.changePassword(userData.UserName, password);
      
      if (response.success) {
        setPasswordSuccess('Đổi mật khẩu thành công');
        setPassword('');
        setConfirmPassword('');
        // Hide password form after 2 seconds
        setTimeout(() => {
          setShowPasswordForm(false);
          setPasswordSuccess('');
        }, 2000);
      } else {
        setPasswordError(response.message || 'Đổi mật khẩu thất bại');
      }
    } catch (error) {
      setPasswordError('Đã xảy ra lỗi: ' + (error.message || 'Không thể kết nối đến máy chủ'));
    } finally {
      setIsChangingPassword(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="p-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <button 
                onClick={onBack} 
                className="mr-4 p-2 hover:bg-gray-100 rounded-lg"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              <div>
                <h1 className="text-xl font-bold text-gray-900">Cài đặt</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* User Info */}
      <div className="bg-white shadow-sm mt-4 p-4">
        <div className="flex items-center">
          <div className="bg-blue-100 p-3 rounded-full">
            <User className="w-6 h-6 text-blue-600" />
          </div>
          <div className="ml-4">
            <h2 className="font-medium text-gray-900">{userData.FullName || userData.UserName}</h2>
            <p className="text-sm text-gray-500">{userData.UserName}</p>
          </div>
        </div>
      </div>

      {/* Settings Options */}
      <div className="bg-white shadow-sm mt-4">
        <div className="p-4 border-b">
          <button 
            onClick={() => setShowPasswordForm(!showPasswordForm)}
            className="w-full flex items-center justify-between py-2"
          >
            <div className="flex items-center">
              <Lock className="w-5 h-5 text-gray-600 mr-3" />
              <span className="font-medium">Đổi mật khẩu</span>
            </div>
            <ChevronLeft className={`w-5 h-5 text-gray-400 transform ${showPasswordForm ? 'rotate-90' : '-rotate-90'}`} />
          </button>

          {/* Password Change Form */}
          {showPasswordForm && (
            <div className="mt-4 space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Mật khẩu mới
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                    placeholder="Nhập mật khẩu mới"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    {showPassword ? (
                      <EyeOff className="h-5 w-5 text-gray-400" />
                    ) : (
                      <Eye className="h-5 w-5 text-gray-400" />
                    )}
                  </button>
                </div>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Xác nhận mật khẩu
                </label>
                <input
                  type={showPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                  placeholder="Nhập lại mật khẩu mới"
                />
              </div>
              
              {passwordError && (
                <div className="p-2 bg-red-50 border border-red-200 rounded text-red-600 text-sm">
                  <AlertCircle className="w-4 h-4 inline mr-1" />
                  {passwordError}
                </div>
              )}
              
              {passwordSuccess && (
                <div className="p-2 bg-green-50 border border-green-200 rounded text-green-600 text-sm">
                  <Check className="w-4 h-4 inline mr-1" />
                  {passwordSuccess}
                </div>
              )}
              
              <button
                onClick={handlePasswordChange}
                disabled={isChangingPassword}
                className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors text-sm flex items-center justify-center gap-1"
              >
                {isChangingPassword ? (
                  <>Đang xử lý...</>
                ) : (
                  <>
                    <Lock className="w-4 h-4" />
                    Đổi mật khẩu
                  </>
                )}
              </button>
            </div>
          )}
        </div>

        {/* Logout Button */}
        <div className="p-4">
          <button 
            onClick={onLogout}
            className="w-full flex items-center py-2 text-red-600"
          >
            <LogOut className="w-5 h-5 mr-3" />
            <span className="font-medium">Đăng xuất</span>
          </button>
        </div>
      </div>

      {/* App Info */}
      <div className="mt-8 p-4 text-center text-gray-500 text-sm">
        <p>Phiên bản 1.0.0</p>
        <p className="mt-1">© 2025 Vận tải TD</p>
      </div>
    </div>
  );
};

export default SettingsScreen;
